import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";
import logoHeader from "../../../../src/assets/images/LOGO HAS.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";

export const ButtonPrint = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-info"
      onClick={() => {
        handlePrint();
      }}
    >
      Print &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDoc = ({ innerRef, data, dataSetting }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const today = new Date();

  const formattedToday = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const dataHeader = {
    header: ["No", "Proper", "No Debitur", "Nama", "Blok", "Tgl Real", "Dajam"],
  };

  const rawRows = data.map((el, index) => {
    let dajam = "";

    switch (dataSetting.application?.label) {
      case "RETENSI SBUM":
        dajam = currencyFormat(el.sbum_amount || 0);
        break;
      case "RETENSI SERTIFIKAT":
        dajam = currencyFormat(el.cert_amount || 0);
        break;
      case "RETENSI IMB":
        dajam = currencyFormat(el.imb_amount || 0);
        break;
      case "RETENSI LISTRIK":
        dajam = currencyFormat(el.electricity_amount || 0);
        break;
      case "RETENSI JKK":
        dajam = currencyFormat(el.jkk_amount || 0);
        break;
      case "RETENSI BESTEK":
        dajam = currencyFormat(el.bestek_amount || 0);
        break;
      case "RETENSI AIR":
        dajam = currencyFormat(el.water_amount || 0);
        break;
      case "RETENSI PPJB":
        dajam = currencyFormat(el.ppjb_amount || 0);
        break;
      case "TAHAP 3":
        dajam = currencyFormat(el.thp3_amount || 0);
        break;
      case "TAHAP 4":
        dajam = currencyFormat(el.thp4_amount || 0);
        break;

      default:
        dajam = 0;
        break;
    }

    return [index + 1, el.sales_branch?.branch_code ?? "", el.code ?? "", el.sls_appl?.name ?? "", el.blok ?? "", handleValidDate(el.createdat), dajam];
  });

  const chunk = (arr, size) =>
    arr.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(arr.slice(i, i + size));
      return acc;
    }, []);

  const dataPrint = chunk(rawRows, 27);

  return (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img src={logoHeader} alt="" width="80" />
          </div>
          <div
            style={{
              textAlign: "center",
              padding: "5px 0",
            }}
          >
            <div style={{ fontSize: "26px", fontWeight: "bold" }}>PT. HIKMAH ALAM SENTOSA</div>
            <div style={{ fontSize: "16px", fontWeight: "bolder" }}>Developer, Kontraktor& Trader</div>
            <div>PerumahanPesonaPalad Blok A No. 19 BogorTelp. 021-22886425</div>
          </div>
        </div>
        <div
          style={{
            height: "4px",
            width: "100%",
            backgroundColor: "black",
          }}
        ></div>
        <div
          style={{
            marginTop: "2px",
            height: "1px",
            width: "100%",
            backgroundColor: "black",
          }}
        ></div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
          }}
        >
          <div style={{ marginTop: "10px", width: "220px" }}>
            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "50px" }}>Nomor</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{"-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "50px" }}>Lampiran</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{"-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "50px" }}>Perihal</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>Permohonan Pencairan {validValue(dataSetting?.application?.label)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              marginTop: "10px",
              border: "1px solid black",
              padding: "10px",
              textAlign: "center",
              width: "220px",

              boxSizing: "border-box",
            }}
          >
            <div>Kepada</div>
            <div>Yth, Kepala Bank BTN (Persero)</div>
            <div>Cabang Bogor</div>
            <div>Di</div>
            <div>Bogor</div>
          </div>
        </div>
        {/* /// */}
        <div
          style={{
            marginTop: "20px",
          }}
        >
          <div style={{ marginBottom: "10px" }}>Dengan Hormat,</div>
          <div>
            Sehubungan dengan telah selesainya Proses Balik Nama Sertifikat Ke atas nama debitur di <span style={{ fontWeight: "bold" }}>{validValue(dataSetting?.proyek?.label)}</span> Lokasi Desa Gandoang, Kecamatan Cileungsi, Kabupaten Bogor.
          </div>
          <div>
            Dengan ini kami Mengajukan <span style={{ fontWeight: "bold" }}>Permohonan Pencairan Dana {validValue(dataSetting?.application?.label)}</span> Sebanyak <span style={{ fontWeight: "bold" }}>{validValue(data.length)} Debitur</span>, dana tersebut mohon dimasukan ke rekening <span style={{ fontWeight: "bold" }}>{validValue(dataSetting?.bank?.label)}</span> Nomor Rekening <span style={{ fontWeight: "bold" }}>{validValue(dataSetting?.bank?.data?.noAccount)}</span> atas nama{" "}
            <span style={{ fontWeight: "bold" }}>{validValue(dataSetting?.bank?.data?.name)}</span>.
          </div>
          <div style={{ marginTop: "10px" }}>Demikian surat Permohonan pencairan ini dibuat agar dapat di tindak lanjuti, atas perhatian dan kerjasamanya kami ucapkan terima kasih.</div>
        </div>

        {/* /// */}
        <div style={{ display: "flex", justifyContent: "end", padding: "0 20px" }}>
          <div style={{ marginTop: "40px", textAlign: "center" }}>
            <div>Bogor, {formattedToday}</div>
            <div>Hormat Kami,</div>
            <div
              style={{
                fontWeight: "bold",
              }}
            >
              PT HIKMAH ALAM SENTOSA
            </div>
            <div style={{ marginTop: "80px", fontWeight: "bold", textDecoration: "underline" }}>{"ANGGA BUDI KUSUMA"}</div>
            <div>Direktur Utama</div>
          </div>
        </div>

        {/* /// */}
        <div
          style={{
            pageBreakBefore: "always",
            height: "0",
            paddingTop: "60px",
          }}
        ></div>
        <div>
          {dataPrint.map((page, pageIndex) => (
            <div key={pageIndex} style={{ padding: "20px 0" }}>
              <table
                style={{
                  width: "100%",
                  border: "1px solid black",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    {dataHeader.header.map((header, index) => (
                      <th
                        key={index}
                        style={{
                          border: "1px solid black",
                          padding: "8px",
                          textAlign: "left",
                          color: "white",
                          background: "gray",
                        }}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {page.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td
                          key={cellIndex}
                          style={{
                            border: "0.2mm solid #000000",
                            padding: "8px",
                            textAlign: "left",
                          }}
                        >
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Page break */}
              {pageIndex < dataPrint.length - 1 && (
                <div
                  style={{
                    pageBreakBefore: "always",
                    height: "0",
                    paddingTop: "40px",
                  }}
                ></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
